import { render, staticRenderFns } from "./BusiNum.vue?vue&type=template&id=1a29d87e"
import script from "./BusiNum.vue?vue&type=script&lang=js"
export * from "./BusiNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports